<template>
  <div class="page-content">
    <div class="page-title">How to establish a clubs and associations for UNESCO</div>

    <div class="text">
      Clubs and Associations may be established by individuals and are frequently set up by schools
      or other educational and cultural institutions. It is up to the National Commissions for
      UNESCO to approve the status of a Club or an Association for UNESCO.<br /><br />
      <b style="margin-right: 20px">•</b>To create a Club or an Association for UNESCO, it shall
      first obtain the approval of its country’s National Commission for UNESCO, which is
      responsible for recognizing the establishment of Clubs or an Association and endorsing the
      activity’s projects.<br />
      <b style="margin-right: 20px">•</b>Once the National Commission has officially approved the
      affiliation to the Movement, the Club or Association is associated with UNESCO’s activities
      and added to its database and relevant documents.<br />
      <b style="margin-right: 20px">•</b>It is entirely to the advantage of Clubs or Associations to
      adopt statutes recognizing laws applying in their country to non-profit-making cultural
      associations (should they exist). Such legal status will entitle them to official recognition
      by public authorities.<br />
      <b style="margin-right: 20px">•</b>Clubs or Associations for UNESCO are legally and
      financially independent from UNESCO, even though UNESCO or the respective National Commission
      for UNESCO may sponsor a number of their activities.<br />
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
